export default __webpack_public_path__ + "static/media/SweepstakesRules.fe4d983d.png";